export default (_, env = 'dev') => ({
  url: `https://api.${env}.carlsbergwebservices.com`,
  clerkIoUrl: 'https://api.clerk.io/v2'
});
